import type { Random } from '../core/Random';
import type { PostInput } from '../state/Store';
import type { MemeImage } from '../state/types';
import type { IconToken } from '../icons/index';

export interface FeedAuthor {
  name: string;
  icon: IconToken;
  color: string;
}

export const FEED_AUTHORS: Record<string, FeedAuthor> = {
  tammy: { name: 'Tammy Lynn :lips: #BossBabe', icon: ':nails:', color: '#e0559b' },
  earl: { name: 'Big Earl', icon: ':ribs:', color: '#5b7a2e' },
  dale: { name: 'Dale "The Deal" Dupree', icon: ':shaka:', color: '#d9822b' },
  darlene: { name: 'Lucky Acres MHP (Darlene)', icon: ':trailer:', color: '#b0417a' },
  jenkins: { name: 'Harold Jenkins', icon: ':old-man:', color: '#6b6b6b' },
  skeeter: { name: 'skeeter :checkered-flag:', icon: ':bike:', color: '#d13b3b' },
  gasngrub: { name: 'Gas-N-Grub', icon: ':gas-pump:', color: '#2a7bd1' },
  watch: { name: 'Lucky Acres Community Watch :eyes:', icon: ':eyes:', color: '#444c8f' },
  apex: { name: 'Apex Capital Holdings LLC', icon: ':briefcase:', color: '#1d2b3a' },
};

type Template = { avatar: keyof typeof FEED_AUTHORS; text: string; meme?: MemeImage; apexOnly?: boolean };

const meme = (icon: IconToken, top: string, bottom: string, bg = '#2b2b2b'): MemeImage => ({
  icon,
  top,
  bottom,
  bg,
});

const POSTS: readonly Template[] = [
  {
    avatar: 'tammy',
    text: 'Some people need to learn to mind there OWN business. U know who u r. :eyeroll:',
  },
  {
    avatar: 'tammy',
    text: 'Hey hun!! :hearts: Want to make $$$ from your phone?? DM me :blossom::sparkles: #bossbabe #blessed',
  },
  { avatar: 'tammy', text: 'Not me crying in the Gas-N-Grub parking lot again :crying: its fine im fine' },
  { avatar: 'tammy', text: 'Who keeps stealing my wind chimes?? I have CAMERAS. :camera:' },
  {
    avatar: 'tammy',
    text: 'Live. Laugh. Love. :hearts:',
    meme: meme(':strawberry-hill:', "IT'S 5 O'CLOCK", 'SOMEWHERE', '#6b2346'),
  },
  { avatar: 'tammy', text: "Essential oils cured my cousin's warts AND her divorce :herb: ask me how" },
  { avatar: 'earl', text: 'Turn left. Turn left. Turn left. Beautiful. :checkered-flag:' },
  { avatar: 'earl', text: "Grill's hot. Bring your own meat and don't touch my tongs." },
  { avatar: 'earl', text: 'Tank learned to open the cooler. We are in trouble now.' },
  {
    avatar: 'earl',
    text: 'Saturday ritual.',
    meme: meme(':ribs:', "IT AIN'T MUCH", "BUT IT'S HONEST BRISKET", '#4a3b22'),
  },
  { avatar: 'dale', text: 'Selling 2 tires, 1 not flat. $40 OBO. no lowballers i know what i have' },
  { avatar: 'dale', text: 'Anybody got a jump? Also a car? Asking for me.' },
  {
    avatar: 'dale',
    text: "Got a business opportunity. Can't explain on here. it's not crypto. ok it's a little crypto",
  },
  {
    avatar: 'dale',
    text: 'mood',
    meme: meme(':runner:', 'ME RUNNING FROM MY PROBLEMS', 'MY PROBLEMS: ON FOOT, GAINING', '#1f3b57'),
  },
  {
    avatar: 'darlene',
    text: "REMINDER: LOT RENT DUE FRIDAYS. CASH OR MONEY ORDER. NO 'MY COUSIN DIED' (AGAIN, DALE).",
  },
  { avatar: 'darlene', text: 'WHOEVER LEFT A RECLINER BY THE DUMPSTER. IT IS NOW MINE. THANK YOU.' },
  { avatar: 'darlene', text: 'PLEASE DO NOT FEED THE RACCOONS. THEY ARE ORGANIZING.' },
  { avatar: 'darlene', text: 'SPEED LIMIT IN THE PARK IS 5 MPH. THAT INCLUDES GOLF CARTS AND SKEETER.' },
  { avatar: 'jenkins', text: 'HOW DO I GET THE WEATHER ON HERE' },
  {
    avatar: 'jenkins',
    text: 'Happy birthday to my granddaughter Crystal. Love, Grandpa Harold Jenkins. (Sent from my phone)',
  },
  { avatar: 'jenkins', text: 'THE BIRDS ARE WATCHING' },
  { avatar: 'jenkins', text: 'who is this. why is my face on the screen' },
  { avatar: 'skeeter', text: 'bro i just jumped the ditch on my bmx no cap (no video)' },
  { avatar: 'skeeter', text: 'fireworks out my trunk :fireworks: legal in like 2 states dm me' },
  { avatar: 'skeeter', text: 'possum in the dumpster the size of a pontiac fr :skull:' },
  {
    avatar: 'skeeter',
    text: 'activated',
    meme: meme(':gator:', 'CROCS IN SPORT MODE', 'SPEED: UNMEASURABLE', '#2f5d2f'),
  },
  { avatar: 'gasngrub', text: "HOT DOGS 2 FOR $3!! SUSHI 'FRESH' DAILY!! LOTTO JACKPOT $412 MILLION!!" },
  { avatar: 'gasngrub', text: 'We are once again asking customers not to bring live bait to the register.' },
  { avatar: 'watch', text: "WHO'S DOG IS THIS :eyes: (it's Tank. everyone knows it's Tank.)" },
  { avatar: 'watch', text: 'Suspicious vehicle parked on Lot 10. UPDATE: it has been there since 2009.' },
  {
    avatar: 'watch',
    text: 'Me checking the dumpster at 3am',
    meme: meme(':raccoon:', 'WHEN YOU HEAR THE DUMPSTER LID', 'AT 3 AM', '#202020'),
  },
  {
    avatar: 'apex',
    apexOnly: true,
    text: 'At Apex Capital Holdings, community is at the heart of everything we do. :briefcase: Lot rents are adjusting to reflect market value.',
  },
  {
    avatar: 'apex',
    apexOnly: true,
    text: "We hear you! That's why we've installed a NEW resident suggestion box. :box: (It is the dumpster.)",
  },
];

export function randomPost(rng: Random, apex: boolean): PostInput {
  const pool = POSTS.filter((p) => apex || !p.apexOnly);
  const t = rng.pick(pool);
  const author = FEED_AUTHORS[t.avatar] ?? { name: t.avatar };
  return {
    author: author.name,
    avatar: t.avatar,
    text: t.text,
    meme: t.meme,
    likes: rng.int(0, 48),
  };
}

export interface PlayerStatus {
  text: string;
  meme?: MemeImage;
}

export const PLAYER_STATUSES: readonly PlayerStatus[] = [
  { text: 'Blessed :pray: #TrailerLife' },
  { text: 'Some people need to mind there business. U know who u r :huffing:' },
  {
    text: 'Grindset :flex:',
    meme: meme(':empty-can:', "IT AIN'T MUCH", "BUT IT'S HONEST WORK", '#5b4a2a'),
  },
  { text: 'Pray for me. Ate the gas station sushi again :sushi::pray:' },
  { text: "Don't come at me today. I am NOT playing. :hundred:" },
  { text: 'New phone who dis' },
  {
    text: 'She still got it :wrench:',
    meme: meme(':car:', 'ON BLOCKS SINCE 2009', 'STILL RUNS IN MY HEART', '#5a1f1f'),
  },
  {
    text: 'Silver linings',
    meme: meme(':tornado:', 'TORNADO SEASON?', 'MORE LIKE FREE REMODEL SEASON', '#3a4a3a'),
  },
  {
    text: 'We have food at home',
    meme: meme(':pickle:', 'THE FOOD AT HOME:', 'ONE (1) PICKLE', '#2d4d22'),
  },
];
